// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IntervalsTable_table__pi59i {
    width: 100%;
}

.IntervalsTable_headerItem__5Lhu4 {
    white-space: nowrap;
    text-align: center;
    vertical-align: bottom;
    font-weight: 300;
    user-select: none;
    color: var(--color-131);
    line-height: 20px;
    padding-left: 20px;
    padding-right: 20px;
}

.IntervalsTable_tableRow__V2tZR {
    border-bottom: 1px solid var(--color-107);
    line-height: 30px;
}

.IntervalsTable_tableRow__V2tZR.IntervalsTable_selected__pU6dv {
    background: var(--color-412);
}

.IntervalsTable_tableRow__V2tZR:first-child {
    border-bottom: 1px solid var(--color-107);
    border-top: 1px solid var(--color-107);
}

.IntervalsTable_tableRowItem__0HzWp {
    text-align: center;
    padding: 8px;
    white-space: nowrap;
    line-height: 20px;
    vertical-align: top;
}

.IntervalsTable_footer__HRn0v {
   font-weight: bold;
   border-bottom: 1px solid var(--color-107);
}

.IntervalsTable_footerItem__wcH8X {
    text-align: center;
    white-space: nowrap;
    padding: 8px;
    line-height: 20px;
    vertical-align: top;
}

.IntervalsTable_tableRowItem__0HzWp.IntervalsTable_selected__pU6dv {
    background: var(--color-412);
}

.IntervalsTable_rowCaret__UUnCd {
    font-size: 13px;
    height: 14px;
    width: 14px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/IntervalsTable/IntervalsTable.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;GACG,iBAAiB;GACjB,yCAAyC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf","sourcesContent":[".table {\n    width: 100%;\n}\n\n.headerItem {\n    white-space: nowrap;\n    text-align: center;\n    vertical-align: bottom;\n    font-weight: 300;\n    user-select: none;\n    color: var(--color-131);\n    line-height: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.tableRow {\n    border-bottom: 1px solid var(--color-107);\n    line-height: 30px;\n}\n\n.tableRow.selected {\n    background: var(--color-412);\n}\n\n.tableRow:first-child {\n    border-bottom: 1px solid var(--color-107);\n    border-top: 1px solid var(--color-107);\n}\n\n.tableRowItem {\n    text-align: center;\n    padding: 8px;\n    white-space: nowrap;\n    line-height: 20px;\n    vertical-align: top;\n}\n\n.footer {\n   font-weight: bold;\n   border-bottom: 1px solid var(--color-107);\n}\n\n.footerItem {\n    text-align: center;\n    white-space: nowrap;\n    padding: 8px;\n    line-height: 20px;\n    vertical-align: top;\n}\n\n.tableRowItem.selected {\n    background: var(--color-412);\n}\n\n.rowCaret {\n    font-size: 13px;\n    height: 14px;\n    width: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `IntervalsTable_table__pi59i`,
	"headerItem": `IntervalsTable_headerItem__5Lhu4`,
	"tableRow": `IntervalsTable_tableRow__V2tZR`,
	"selected": `IntervalsTable_selected__pU6dv`,
	"tableRowItem": `IntervalsTable_tableRowItem__0HzWp`,
	"footer": `IntervalsTable_footer__HRn0v`,
	"footerItem": `IntervalsTable_footerItem__wcH8X`,
	"rowCaret": `IntervalsTable_rowCaret__UUnCd`
};
export default ___CSS_LOADER_EXPORT___;
